import { useEffect, useState } from "react";
import styles from "./Switcher.module.scss";

export default function Switcher({
  bool,
  onToggle,
  label,
  labelOn,
  labelOff,
  disabled,
  switchStyle,
}) {
  const [active, setActive] = useState(true);

  useEffect(() => {
    setActive(bool);
  }, [bool]);

  const handlerChangeActive = () => {
    setActive(!active);
    onToggle(!active);
  };

  return (
    <div
      className={`${styles.switchContainer} ${switchStyle} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <div
        className={`${styles.toggleSwitch} ${active ? styles.on : ""}`}
        onClick={handlerChangeActive}
      >
        <div className={styles.thumb} />
      </div>
      <span className={styles.switchLabel}>
        {label ? label : active ? labelOn : labelOff}
      </span>
      {/* //   <label className={styles.switch}>
    //     <input
    //       type="checkbox"
    //       checked={isOn}
    //       onChange={handleToggle}
    //       disabled={disabled}
    //     />
    //     <span
    //       className={`${styles.slider} ${isOn ? styles.checked : ""}`}
    //     ></span>
    //   </label>
    //   <span className={styles.switchLabel}>{isOn ? labelOn : labelOff}</span> */}
    </div>
  );
}
